import script from "./siddar.vue?vue&type=script&lang=js&setup=true"
export * from "./siddar.vue?vue&type=script&lang=js&setup=true"

import "./siddar.vue?vue&type=style&index=0&id=a8fa19b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8fa19b4"]])

export default __exports__